import {
    useState,
    useEffect,
} from 'react';

/**
 *
 * @desk Hook that returns an element ref width and height
 * @param {*} elementRef
 *
 */
const useWindowDimensions = () => {

    const [
        dimensions,
        setDimensions,
    ] = useState({
        width: 0,
        height: 0,
    });

    const updateElementDimensions = () => {

        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });

    };

    useEffect(() => {

        updateElementDimensions();
        // Update values when the window is resized
        window.addEventListener('resize', updateElementDimensions);

        return () => {

            // Remove event listener
            window.removeEventListener('resize', updateElementDimensions);

        };

    }, []);

    return dimensions;

};

export default useWindowDimensions;
